var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustratieHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 578 445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #bcd86b;\n      }\n\n      .cls-4 {\n        fill: #77c58c;\n      }\n\n      .cls-5 {\n        fill: #f2f2f2;\n      }\n\n      .cls-6 {\n        fill: #fff;\n      }\n\n      .cls-7 {\n        fill: #e3e3e3;\n      }\n\n      .cls-8 {\n        fill: #dde3e9;\n      }\n\n      .cls-9 {\n        fill: #c5cfd6;\n      }\n\n      .cls-10 {\n        fill: #afb9c5;\n      }\n\n      .cls-11 {\n        fill: #f8f8f8;\n      }\n\n      .cls-12 {\n        fill: #454545;\n      }\n\n      .cls-13 {\n        fill: #89c5cc;\n      }\n\n      .cls-14 {\n        fill: #919191;\n      }\n\n      .cls-15 {\n        fill: #757575;\n      }\n\n      .cls-16 {\n        fill: #191847;\n      }\n\n      .cls-17 {\n        fill: #2f3676;\n      }\n\n      .cls-18 {\n        fill: #b28b67;\n      }\n\n      .cls-19 {\n        fill: #f04e36;\n      }\n\n      .cls-20 {\n        fill: #987f51;\n      }\n\n      .cls-21 {\n        fill: #e0c1a4;\n      }\n\n      .cls-22 {\n        fill: #c3104e;\n      }\n\n      .cls-23 {\n        fill: #ee135f;\n      }\n\n      .cls-24 {\n        fill: #b7c4cd;\n      }\n\n      .cls-25 {\n        fill: #b1bac0;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 578,
    height: 445
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Twisted_Leaf",
    "data-name": "Twisted Leaf",
    className: "cls-3",
    d: "M499.835,123.02549a5.451,5.451,0,0,0-1.756-.472,28.46658,28.46658,0,0,0-5.487-.509,101.24239,101.24239,0,0,0-16.966,1.525c-3.531.61-7.8,2.663-11.314,1.548a24.085,24.085,0,0,0-18.111.927,25.383,25.383,0,0,0-11.69,12.555,31.91308,31.91308,0,0,0-2.2,5.626c-.174.4-.342.8-.492,1.207-.428,1.156-.812,2.333-1.169,3.512-.152.5-.536,1.613-.081,1.828a33.42307,33.42307,0,0,0-1.91,4.155c-1.564,4.155-3.273,8.717-3.822,13.117a20.521,20.521,0,0,0-.022,4.9c.093.808.055,2.431.6,3.045,1.162,1.3,1.759-.521,1.628-1.39-1-6.621.931-12.839,3.22-19.064a39.16908,39.16908,0,0,1,6.637-11.042,27.86893,27.86893,0,0,1,7.593-6.614,118.71072,118.71072,0,0,1,11.563-5.732c2.575-1.168,5.153-2.3,7.8-3.31a7.77493,7.77493,0,0,1,2.17-.793c1.38,0,3.336,1.013,4.669,1.392,4.385,1.247,8.826,2.843,13.357,3.479a17.225,17.225,0,0,0,8.348-1.02,7.81378,7.81378,0,0,0,1.314-.716,19.06806,19.06806,0,0,0,5.59-3.163,22.29418,22.29418,0,0,0,2.619-2.823,1.47793,1.47793,0,0,0,.346-.929c.18-.094.3-.2.326-.332.2-.945-1.606-.963-2.76-.907"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Leaf",
    className: "cls-3",
    d: "M121.005,175.64375a234.7531,234.7531,0,0,0-20.20984-19.13111c-4.26373-3.46124-8.75806-6.60843-13.15926-9.88968q.762.6672,1.49222,1.37207c-1.374-.93255-3.17209-1.46041-4.63038-2.322-1.62477-.96282-3.17782-2.06485-4.70048-3.17475-2.97276-2.16674-5.9018-4.3752-8.95836-6.42871-3.405-2.28825-6.93448-4.40254-10.39732-6.60462a93.59057,93.59057,0,0,0-9.05923-5.44209c-1.71613-.83637-3.43159-1.81979-5.155-2.68575-.57567-.29025-6.41935-3.9815-6.405-3.99234.3196-.2408,3.26383,1.13829,3.71842,1.32436,1.32813.5425,2.59907,1.192,3.876,1.83943a16.92658,16.92658,0,0,1-1.55663-4.36854c-.09368-.47178-.84054-3.90853-.45781-4.19689.191-.14388,2.05523,6.00451,2.15076,6.59514a10.9247,10.9247,0,0,0,.22347,1.62657c.25392.73433.24082.51247.79976.92681a35.02229,35.02229,0,0,0,3.49372,1.86568,25.5421,25.5421,0,0,0,3.56411,2.03559,97.80512,97.80512,0,0,1,9.99959,6.25294,23.5768,23.5768,0,0,1-1.94811-4.96792c-.11376-.41532-1.30914-4.10159-1.01831-4.32071.32679-.24622,2.61031,5.38964,2.74534,5.923.24748.99346.30272,2.09418.61717,3.05848.34547,1.05867,1.42213,1.43366,2.39328,2.051,3.57183,2.27026,7.02233,4.68205,10.41425,7.20562,3.70163-6.583-.56537-14.53224-4.16257-20.05637a45.94479,45.94479,0,0,0-9.76555-10.37114A94.65373,94.65373,0,0,0,48.743,99.70747a63.54351,63.54351,0,0,0-20.98689-6.45708,67.95123,67.95123,0,0,0-11.67385-.33067,19.41449,19.41449,0,0,0-5.54515.95258,18.10059,18.10059,0,0,0-2.38332,1.02285c-.58717.29961-2.00985.61747-2.34461,1.06258a16.98783,16.98783,0,0,0-3.98275,11.76252A32.89207,32.89207,0,0,0,5.23115,120.1608a38.14737,38.14737,0,0,0,8.14777,11.4059,86.60917,86.60917,0,0,0,8.50334,6.77905c10.41029,7.58439,23.60593,14.18245,37.08926,12.48592a35.87132,35.87132,0,0,0,12.3921-4.14732c.91449-.4886,1.82257-.9824,2.68526-1.55973.58338-.38944,2.13695-2.14116,2.72245-2.20528.80233-.08719,2.52961,1.54367,3.28021,2.03782q8.57641,5.66244,16.73572,11.89342c5.796,4.401,11.3138,9.10942,16.66679,14.03464,2.27633,2.09525,4.53845,4.19492,6.74851,6.36014.51492.50387,1.7759,2.357,2.70606,2.44284a.83834.83834,0,0,0,.90378-.99659c-.14655-.94925-2.14408-2.37025-2.80346-3.05588"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_10",
    "data-name": "Fill 10",
    className: "cls-3",
    d: "M493.038,149.73149a34.59954,34.59954,0,0,0-7.831-.461,48.657,48.657,0,0,0-35.907,17.036c-7.454,8.823-9.503,19.792-10.975,30.88-.146,1.1-.209,2.195-.291,3.3-.018.237-.044.448-.072.647a1.424,1.424,0,0,0-.54,1.784,73.70867,73.70867,0,0,0-3.281,8.606c-2.725,8.69-5.5,17.545-3.79,26.683a127.66856,127.66856,0,0,1,2.241-15.118q.087-.426.185-.846l.019-.089a33.057,33.057,0,0,1,1.379-4.43l.018-.047c.074-.19.153-.38.231-.569.161-.392.326-.783.5-1.172q.089-.2.171-.4c.818-2,1.163-4.262,1.9-6.336q.263-.707.55-1.409l.034-.082c.519-1.257,1.092-2.5,1.7-3.728a4.59026,4.59026,0,0,0,.789-1.42,8.87531,8.87531,0,0,0,.655-1.266q.535-1.036,1.072-2.07l-.032.012q.54-.993,1.078-1.977l.238-.433.385-.69c1.2-2.147,2.472-4.252,3.794-6.33.472-.742,1.6-1.805,1.814-2.638.008-.031.01-.06.015-.09a47.26608,47.26608,0,0,1,10.121-10.686c-.479.517-1.5,2.272-1.764,2.62-.823,1.064-1.716,2.055-2.613,3.057a65.078,65.078,0,0,0-4.567,5.608,106.57412,106.57412,0,0,0-6.823,11.2c-.02.023-.041.044-.06.067a27.26965,27.26965,0,0,0-2.456,4.707c2.975-1.378,6.264-2.275,9.318-3.5a76.56361,76.56361,0,0,0,8.866-4.173,98.938,98.938,0,0,0,11.336-7.221,44.90022,44.90022,0,0,0,10.626-9.753c3.611-4.358,6.921-8.758,8.968-14.058a42.21939,42.21939,0,0,0,2.266-8.063c.021-.12.047-.25.075-.384a26.41332,26.41332,0,0,0,1.269-2.91c.572-1.573,1.922-3.3-.61-3.857"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Leave_the_Leaf_",
    "data-name": "Leave the Leaf ",
    className: "cls-4",
    d: "M98.97491,173.20244a.76042.76042,0,0,0-.0337-.64607c-.24974-.67024-1.9998-1.35129-2.9362-1.7172-.16812-.065-.31186-.1218-.40768-.16282a21.31851,21.31851,0,0,0-2.48591-.8886,74.39243,74.39243,0,0,0-7.88163-1.6819c-.98114-.16981-2.001-.34375-3.02959-.51494-.191-.03212-.33687-.04781-.45463-.06127-.42061-.0459-.42061-.0459-.56837-.57929l-.02608-.09413a5.17257,5.17257,0,0,1-.13737-.88775,6.33945,6.33945,0,0,0-.09964-.73681,12.81524,12.81524,0,0,0-2.73586-5.39624,13,13,0,0,0-4.50479-3.48295,22.27492,22.27492,0,0,0-5.48126-1.71116,44.586,44.586,0,0,0-9.80871-.7967,40.30038,40.30038,0,0,0-9.80076,1.44531,34.95792,34.95792,0,0,0-10.93337,5.7292,22.57666,22.57666,0,0,0-4.965,4.93462c-.19335.266-.37895.54971-.55968.83888a18.50017,18.50017,0,0,0-1.07993,1.99958c-.09084.19441-.17119.406-.249.60972a6.67327,6.67327,0,0,1-.37227.85224l-.06794.1238c-.04792.088-.08745.15879-.12455.21815-.15.24-.27836.29065-.76246.40672a.515.515,0,0,0-.332.19345.306.306,0,0,0,.05353.35775.841.841,0,0,0,.86782.27,6.289,6.289,0,0,0,.63261,3.79162,9.06782,9.06782,0,0,0,2.47806,2.87662,26.173,26.173,0,0,0,6.92912,3.59839,35.67879,35.67879,0,0,0,7.92286,1.98008,40.86048,40.86048,0,0,0,8.04487.24146,58.74679,58.74679,0,0,0,15.97674-3.57591,16.79984,16.79984,0,0,0,7.08716-4.679,8.99931,8.99931,0,0,0,.88574-1.187,9.86517,9.86517,0,0,0,1.19791-2.894c.01876-.07908.04748-.17787.08045-.29288a2.81826,2.81826,0,0,0,.18073-1.48728c-.14066-.27306-.41086-.27094-.754-.26723-.1007.00075-.20553.00244-.3145-.00435l-1.2615-.07027c-1.10951-.06254-2.25515-.12763-3.38405-.17989-.1784-.0089-.40153-.03869-.63749-.07059a3.775,3.775,0,0,0-1.60855-.01124.51978.51978,0,0,0-.08469.111,1.09107,1.09107,0,0,1-.29617.33612c-.10017.04706-.25143-.02979-.3517-.08067-.05014-.02544-.08957-.04536-.10272-.03943a4.80017,4.80017,0,0,0-1.21179,1.21434c-.17745.22164-.34471.43078-.49417.585-.41256.42612-.90652.924-1.44319,1.38457a21.5147,21.5147,0,0,1-1.72113,1.33115c-.12561.08777-.33294.19875-.55173.31673a3.85536,3.85536,0,0,0-1.04908.68985,18.63754,18.63754,0,0,1,2.97065-3.28133,16.97893,16.97893,0,0,1,1.87493-1.50743c.07939-.05533.22737-.13738.398-.23119a3.77888,3.77888,0,0,0,1.06964-.736.194.194,0,0,0,.03435-.09646,44.30406,44.30406,0,0,0-5.26406.27718c-.90493.1007-1.8743.19886-2.8336.23373-.06264.00212-.23828-.00741-.46057-.0178a5.97986,5.97986,0,0,0-1.738.03169c.18232-.29171,1.26171-.498,1.90566-.62264.18678-.03657.34737-.0671.44266-.09127a20.7889,20.7889,0,0,1,2.3549-.46216,39.77405,39.77405,0,0,1,4.08948-.31673c1.93884-.06063,3.86677.0264,5.67587.12052.41552.02385.84843.035,1.26723.04792a21.81413,21.81413,0,0,1,3.42232.2828.185.185,0,0,1,.01929-.11766c.062-.09921.25281-.046.43715.00435a1.95864,1.95864,0,0,0,.19143.04653c.73108.12084,1.44711.23935,2.15795.36051,1.50085.25525,2.73194.47986,3.87451.70458l.06085.01208c1.34015.26331,2.7295.53848,4.06616.8904A22.4295,22.4295,0,0,1,95.89,172.2779c.4698.21815.93376.45506,1.38033.70469C97.63147,173.19534,98.711,173.62474,98.97491,173.20244ZM77.36543,162.48308a13.91887,13.91887,0,0,1,1.9486,3.81813c-.37238-.84-.73119-1.58672-1.094-2.28165-.082-.15741-.26224-.47287-.43629-.77741C77.56588,162.86426,77.36109,162.50513,77.36543,162.48308Zm-14.29431,2.65573c.124-.19843,2.03139.69886,2.33974.8621a10.19983,10.19983,0,0,1,2.70088,2.15975h0a13.15736,13.15736,0,0,0-1.45135-.78917c-1.47117-.74614-3.48433-1.76851-3.59467-2.16177A.092.092,0,0,1,63.07112,165.13881Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    className: "cls-5",
    x: 93.84,
    y: 35.29148,
    width: 116.896,
    height: 222.02901,
    rx: 8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Touch",
    className: "cls-6",
    cx: 151.921,
    cy: 232.32449,
    r: 11.028
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Lens",
    className: "cls-6",
    cx: 142.363,
    cy: 48.52448,
    r: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Sensor",
    className: "cls-6",
    x: 147.51,
    y: 47.05448,
    width: 15.439,
    height: 2.941,
    rx: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    className: "cls-6",
    x: 104.133,
    y: 55.87749,
    width: 96.311,
    height: 39.701,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Name",
    className: "cls-7",
    d: "M135.784,67.78749h47.713a2.97775,2.97775,0,0,1,2.978,2.9775h0a2.97776,2.97776,0,0,1-2.978,2.9775H135.784a2.97775,2.97775,0,0,1-2.978-2.9775h0A2.97774,2.97774,0,0,1,135.784,67.78749Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Name-2",
    className: "cls-7",
    d: "M135.784,77.71249h30.069a2.97775,2.97775,0,0,1,2.978,2.9775h0a2.97776,2.97776,0,0,1-2.978,2.9775H135.784a2.97775,2.97775,0,0,1-2.978-2.9775h0A2.97774,2.97774,0,0,1,135.784,77.71249Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Avatar",
    className: "cls-7",
    cx: 119.572,
    cy: 75.72748,
    r: 8.822
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Background-2",
    className: "cls-6",
    x: 104.133,
    y: 101.45949,
    width: 96.311,
    height: 30.878,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Name-3",
    className: "cls-7",
    d: "M135.122,110.72249h49.037a2.316,2.316,0,0,1,2.316,2.316h0a2.316,2.316,0,0,1-2.316,2.316H135.122a2.316,2.316,0,0,1-2.316-2.316h0A2.316,2.316,0,0,1,135.122,110.72249Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Name-4",
    className: "cls-7",
    d: "M135.122,118.44249h31.393a2.316,2.316,0,0,1,2.316,2.316h0a2.316,2.316,0,0,1-2.316,2.316H135.122a2.316,2.316,0,0,1-2.316-2.316h0A2.316,2.316,0,0,1,135.122,118.44249Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Avatar-2",
    className: "cls-7",
    cx: 119.572,
    cy: 116.89849,
    r: 8.822
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Background-3",
    className: "cls-6",
    x: 104.133,
    y: 138.21949,
    width: 96.311,
    height: 30.878,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Name-5",
    className: "cls-7",
    d: "M135.122,147.48249h49.037a2.316,2.316,0,0,1,2.316,2.316h0a2.316,2.316,0,0,1-2.316,2.316H135.122a2.316,2.316,0,0,1-2.316-2.316h0A2.316,2.316,0,0,1,135.122,147.48249Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Name-6",
    className: "cls-7",
    d: "M135.122,155.20249h31.393a2.316,2.316,0,0,1,2.316,2.316h0a2.316,2.316,0,0,1-2.316,2.316H135.122a2.316,2.316,0,0,1-2.316-2.316h0A2.316,2.316,0,0,1,135.122,155.20249Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Avatar-3",
    className: "cls-7",
    cx: 119.572,
    cy: 153.65849,
    r: 8.822
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Background-4",
    className: "cls-6",
    x: 104.133,
    y: 174.97948,
    width: 96.311,
    height: 30.878,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Name-7",
    className: "cls-8",
    d: "M135.122,184.24248h49.037a2.316,2.316,0,0,1,2.316,2.316h0a2.316,2.316,0,0,1-2.316,2.316H135.122a2.316,2.316,0,0,1-2.316-2.316h0A2.316,2.316,0,0,1,135.122,184.24248Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Name-8",
    className: "cls-8",
    d: "M135.122,191.96248h31.393a2.316,2.316,0,0,1,2.316,2.316h0a2.316,2.316,0,0,1-2.316,2.316H135.122a2.316,2.316,0,0,1-2.316-2.316h0A2.316,2.316,0,0,1,135.122,191.96248Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Avatar-4",
    className: "cls-7",
    cx: 119.572,
    cy: 190.41848,
    r: 8.822
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Container-2",
    className: "cls-7",
    x: 142.36299,
    y: 54.40648,
    width: 116.896,
    height: 222.02901,
    rx: 8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Touch-2",
    className: "cls-6",
    cx: 200.44399,
    cy: 251.43949,
    r: 11.028
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Lens-2",
    className: "cls-6",
    cx: 190.88599,
    cy: 67.63948,
    r: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Sensor-2",
    className: "cls-6",
    x: 196.03299,
    y: 66.16948,
    width: 15.439,
    height: 2.941,
    rx: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Container-3",
    className: "cls-6",
    x: 152.65599,
    y: 74.99248,
    width: 96.311,
    height: 39.701,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Label",
    className: "cls-7",
    d: "M162.251,86.90248h47.713a2.97776,2.97776,0,0,1,2.978,2.9775h0a2.97775,2.97775,0,0,1-2.978,2.9775H162.251a2.97775,2.97775,0,0,1-2.978-2.9775h0A2.97776,2.97776,0,0,1,162.251,86.90248Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Label-2",
    className: "cls-7",
    d: "M162.251,96.82748H192.32a2.97775,2.97775,0,0,1,2.978,2.9775h0a2.97774,2.97774,0,0,1-2.978,2.9775H162.251a2.97775,2.97775,0,0,1-2.978-2.9775h0A2.97776,2.97776,0,0,1,162.251,96.82748Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Background-5",
    className: "cls-8",
    cx: 238.67399,
    cy: 94.84248,
    r: 5.146
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Indicator",
    className: "cls-5",
    cx: 238.67499,
    cy: 94.84348,
    r: 2.206
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Background-6",
    className: "cls-6",
    x: 152.65599,
    y: 120.57448,
    width: 96.311,
    height: 30.878,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Name-9",
    className: "cls-8",
    d: "M183.645,129.83748h49.037a2.316,2.316,0,0,1,2.316,2.316h0a2.316,2.316,0,0,1-2.316,2.316H183.645a2.316,2.316,0,0,1-2.316-2.316h0A2.316,2.316,0,0,1,183.645,129.83748Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Name-10",
    className: "cls-8",
    d: "M183.645,137.55748h31.393a2.316,2.316,0,0,1,2.316,2.316h0a2.316,2.316,0,0,1-2.316,2.316H183.645a2.316,2.316,0,0,1-2.316-2.316h0A2.316,2.316,0,0,1,183.645,137.55748Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Avatar-5",
    className: "cls-9",
    cx: 168.09499,
    cy: 136.01348,
    r: 8.822
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Container-4",
    className: "cls-6",
    x: 152.65599,
    y: 157.33449,
    width: 96.311,
    height: 30.878,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Label-3",
    className: "cls-8",
    d: "M161.589,166.59749h49.037a2.316,2.316,0,0,1,2.316,2.316h0a2.316,2.316,0,0,1-2.316,2.316H161.589a2.316,2.316,0,0,1-2.316-2.316h0A2.316,2.316,0,0,1,161.589,166.59749Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Label-4",
    className: "cls-10",
    d: "M161.589,174.31749h31.393a2.316,2.316,0,0,1,2.316,2.316h0a2.316,2.316,0,0,1-2.316,2.316H161.589a2.316,2.316,0,0,1-2.316-2.316h0A2.316,2.316,0,0,1,161.589,174.31749Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Background-7",
    className: "cls-8",
    cx: 238.67399,
    cy: 172.77349,
    r: 5.146
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-2",
    className: "cls-5",
    cx: 238.67499,
    cy: 172.77449,
    r: 2.206
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Background-8",
    className: "cls-6",
    x: 152.65599,
    y: 194.09448,
    width: 96.311,
    height: 30.878,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Name-11",
    className: "cls-8",
    d: "M183.645,203.35748h49.037a2.316,2.316,0,0,1,2.316,2.316h0a2.316,2.316,0,0,1-2.316,2.316H183.645a2.316,2.316,0,0,1-2.316-2.316h0A2.316,2.316,0,0,1,183.645,203.35748Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Name-12",
    className: "cls-8",
    d: "M183.645,211.07748h31.393a2.316,2.316,0,0,1,2.316,2.316h0a2.316,2.316,0,0,1-2.316,2.316H183.645a2.316,2.316,0,0,1-2.316-2.316h0A2.316,2.316,0,0,1,183.645,211.07748Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Avatar-6",
    className: "cls-9",
    cx: 168.09499,
    cy: 209.53348,
    r: 8.822
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Container-5",
    className: "cls-5",
    x: 190.886,
    y: 72.78648,
    width: 246.291,
    height: 254.37801,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Background-9",
    className: "cls-11",
    x: 373.95,
    y: 104.39948,
    width: 51.464,
    height: 59.551,
    rx: 8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Avatar-7",
    className: "cls-7",
    cx: 399.682,
    cy: 127.19048,
    r: 11.763
  }), /*#__PURE__*/React.createElement("path", {
    id: "Name-13",
    className: "cls-7",
    d: "M383.508,141.89448h32.348a2.20575,2.20575,0,0,1,2.206,2.2055h0a2.20575,2.20575,0,0,1-2.206,2.2055H383.508a2.20575,2.20575,0,0,1-2.206-2.2055h0A2.20575,2.20575,0,0,1,383.508,141.89448Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Name-14",
    className: "cls-7",
    d: "M389.39,149.24648h20.585a2.20575,2.20575,0,0,1,2.206,2.2055h0a2.20575,2.20575,0,0,1-2.206,2.2055H389.39a2.20575,2.20575,0,0,1-2.206-2.2055h0A2.20575,2.20575,0,0,1,389.39,149.24648Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Header",
    className: "cls-12",
    d: "M198.886,72.78648H429.177a8,8,0,0,1,8,8v11.85H190.886v-11.85A8,8,0,0,1,198.886,72.78648Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Background-10",
    className: "cls-11",
    x: 373.95,
    y: 169.83248,
    width: 51.464,
    height: 142.62801,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Data",
    className: "cls-7",
    x: 387.184,
    y: 183.06648,
    width: 24.997,
    height: 19.115,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Data-2",
    className: "cls-7",
    x: 387.184,
    y: 208.06348,
    width: 24.997,
    height: 18.38,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Data-3",
    className: "cls-7",
    x: 387.184,
    y: 232.32448,
    width: 24.997,
    height: 18.38,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Data-4",
    className: "cls-7",
    x: 387.184,
    y: 280.84748,
    width: 24.997,
    height: 18.38,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Data-5",
    className: "cls-7",
    x: 387.184,
    y: 256.58648,
    width: 24.997,
    height: 18.38,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Container-6",
    className: "cls-11",
    d: "M205.59,105.13548H365.128a2.941,2.941,0,0,1,2.941,2.941v28.672a2.941,2.941,0,0,1-2.941,2.941H205.59a2.941,2.941,0,0,1-2.941-2.941h0v-28.672a2.941,2.941,0,0,1,2.941-2.941Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Label-5",
    className: "cls-7",
    d: "M211.858,115.50148H329.452a2.59176,2.59176,0,0,1,2.592,2.5915h0a2.59175,2.59175,0,0,1-2.592,2.5915H211.858a2.59175,2.59175,0,0,1-2.592-2.5915h0A2.59176,2.59176,0,0,1,211.858,115.50148Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Label-6",
    className: "cls-7",
    d: "M211.858,124.14048h77.229a2.59176,2.59176,0,0,1,2.592,2.5915h0a2.59175,2.59175,0,0,1-2.592,2.5915H211.858a2.59175,2.59175,0,0,1-2.592-2.5915h0A2.59176,2.59176,0,0,1,211.858,124.14048Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Background-11",
    className: "cls-7",
    cx: 350.39,
    cy: 122.41248,
    r: 5.146
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-3",
    className: "cls-7",
    cx: 350.391,
    cy: 122.41348,
    r: 2.206
  }), /*#__PURE__*/React.createElement("path", {
    id: "Container-7",
    className: "cls-11",
    d: "M205.59,145.57148H365.128a2.941,2.941,0,0,1,2.941,2.941v22.791a2.941,2.941,0,0,1-2.941,2.941H205.59a2.941,2.941,0,0,1-2.941-2.941h0v-22.791a2.941,2.941,0,0,1,2.941-2.941Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label-7",
    className: "cls-7",
    x: 209.266,
    y: 154.17348,
    width: 122.778,
    height: 4.301,
    rx: 2.15
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label-8",
    className: "cls-7",
    x: 209.266,
    y: 161.34148,
    width: 82.413,
    height: 4.301,
    rx: 2.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Background-12",
    className: "cls-7",
    cx: 350.39,
    cy: 159.90748,
    r: 5.146
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-4",
    className: "cls-7",
    cx: 350.391,
    cy: 159.90848,
    r: 2.206
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Container-8",
    className: "cls-11",
    x: 202.649,
    y: 180.12548,
    width: 165.41901,
    height: 28.673,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label-9",
    className: "cls-7",
    x: 209.266,
    y: 188.72748,
    width: 122.778,
    height: 4.301,
    rx: 2.15
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label-10",
    className: "cls-7",
    x: 209.266,
    y: 195.89548,
    width: 82.413,
    height: 4.301,
    rx: 2.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Background-13",
    className: "cls-7",
    cx: 350.39,
    cy: 194.46148,
    r: 5.146
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-5",
    className: "cls-7",
    cx: 350.391,
    cy: 194.46248,
    r: 2.206
  }), /*#__PURE__*/React.createElement("path", {
    id: "Container-9",
    className: "cls-11",
    d: "M205.59,283.78848H365.128a2.941,2.941,0,0,1,2.941,2.941v22.791a2.941,2.941,0,0,1-2.941,2.941H205.59a2.941,2.941,0,0,1-2.941-2.941h0v-22.791a2.941,2.941,0,0,1,2.941-2.941Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label-11",
    className: "cls-7",
    x: 209.266,
    y: 292.39048,
    width: 122.778,
    height: 4.301,
    rx: 2.15
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label-12",
    className: "cls-7",
    x: 209.266,
    y: 299.55848,
    width: 82.413,
    height: 4.301,
    rx: 2.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Background-14",
    className: "cls-7",
    cx: 350.39,
    cy: 298.12448,
    r: 5.146
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-6",
    className: "cls-7",
    cx: 350.391,
    cy: 298.12548,
    r: 2.206
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Container-10",
    className: "cls-11",
    x: 202.649,
    y: 249.23448,
    width: 165.41901,
    height: 28.673,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label-13",
    className: "cls-7",
    x: 209.266,
    y: 257.83648,
    width: 122.778,
    height: 4.301,
    rx: 2.15
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label-14",
    className: "cls-7",
    x: 209.266,
    y: 265.00448,
    width: 82.413,
    height: 4.301,
    rx: 2.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Background-15",
    className: "cls-7",
    cx: 350.39,
    cy: 263.57048,
    r: 5.146
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-7",
    className: "cls-7",
    cx: 350.391,
    cy: 263.57148,
    r: 2.206
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Container-11",
    className: "cls-11",
    x: 202.649,
    y: 214.67948,
    width: 165.41901,
    height: 28.673,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label-15",
    className: "cls-7",
    x: 209.266,
    y: 223.28148,
    width: 122.778,
    height: 4.301,
    rx: 2.15
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label-16",
    className: "cls-7",
    x: 209.266,
    y: 230.44948,
    width: 82.413,
    height: 4.301,
    rx: 2.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Background-16",
    className: "cls-7",
    cx: 350.39,
    cy: 229.01548,
    r: 5.146
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-8",
    className: "cls-7",
    cx: 350.391,
    cy: 229.01648,
    r: 2.206
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    className: "cls-3",
    d: "M498.188,198.04648c-2.9-1.967-6.756-2.482-10.227-2.482-13.554,0-26.294,5.029-37.3,12.522a87.24748,87.24748,0,0,0-16.188,14.778,43.27928,43.27928,0,0,0-6.936,10.323,35.56534,35.56534,0,0,0-2.52,7.953,81.72467,81.72467,0,0,0-1.43,10.15c-.094,1.338-.871,8.438,1.353,8.558a3.0721,3.0721,0,0,0,0,.491c-4.831,7.553-7.815,16.405-10.583,24.8a168.89959,168.89959,0,0,0-5.949,22.225,242.16722,242.16722,0,0,0-3.615,30.129c-.119,2.171-.2,4.338-.276,6.51q-.092,2.778-.185,5.556a35.801,35.801,0,0,0-.1,6.528c.287,1.8,1.842,1.525,1.911-.263.083-2.159.069-4.323.164-6.484q.189-4.3.4-8.6a201.1438,201.1438,0,0,1,11.4-58.361,136.06807,136.06807,0,0,1,9.906-21.864,152.45842,152.45842,0,0,1,12.166-17.771,112.63073,112.63073,0,0,1,13.83-15.324,106.3674,106.3674,0,0,1,13.607-10,149.33759,149.33759,0,0,1,18.639-10.541c3.406-1.532,6.876-2.9,10.309-4.375.618-.265,1.28-.521,1.874-.827,1.981-1.022,1.329-2.561-.25-3.631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_20",
    "data-name": "Fill 20",
    className: "cls-13",
    d: "M443.66,267.61348a37.425,37.425,0,0,1,15.454,2.9,68.68852,68.68852,0,0,1,12.225,7.1,38.364,38.364,0,0,1,12.728,14.162c1.792,3.521,3.107,8.5,1.9,12.344-1.418,4.523-5.311,8.3-10.439,7.5-3.171-.492-6.078-2.591-8.488-4.567a32.1,32.1,0,0,1-7.1-8.361c-3.109-5.148-4.935-10.969-7.576-16.348-1.253-2.553-2.464-5.125-3.965-7.551a12.18108,12.18108,0,0,0-2.654-3.287c-.6-.478-3.146-1.3-2.173-2.377-14.255.185-26.884,11.136-29.62,24.685-.255,1.263-.454,2.537-.665,3.807-.133.8-.079,3.762-.8,4.275-1.582,1.131-.917-2.3-.849-2.8q.263-1.918.559-3.831a31.883,31.883,0,0,1,9.306-18.33,32.435,32.435,0,0,1,22.157-9.321"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Value",
    className: "cls-7",
    d: "M376.89048,41.17248h0a2.20575,2.20575,0,0,1,2.2055,2.206v13.968a2.20575,2.20575,0,0,1-2.2055,2.206h0a2.20575,2.20575,0,0,1-2.2055-2.206v-13.968A2.20575,2.20575,0,0,1,376.89048,41.17248Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Value-2",
    className: "cls-7",
    d: "M387.18348,29.40948h0a2.20575,2.20575,0,0,1,2.2055,2.206v25.731a2.20575,2.20575,0,0,1-2.2055,2.206h0a2.20575,2.20575,0,0,1-2.2055-2.206v-25.731A2.20575,2.20575,0,0,1,387.18348,29.40948Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Value-3",
    className: "cls-7",
    d: "M397.47648,23.52848h0a2.20575,2.20575,0,0,1,2.2055,2.206v31.613a2.20575,2.20575,0,0,1-2.2055,2.206h0a2.20575,2.20575,0,0,1-2.2055-2.206v-31.613A2.20575,2.20575,0,0,1,397.47648,23.52848Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Value-4",
    className: "cls-7",
    d: "M407.76848,29.40948h0a2.20575,2.20575,0,0,1,2.2055,2.206v25.731a2.20575,2.20575,0,0,1-2.2055,2.206h0a2.20575,2.20575,0,0,1-2.2055-2.206v-25.731A2.20575,2.20575,0,0,1,407.76848,29.40948Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Value-5",
    className: "cls-7",
    d: "M418.06148,17.64648h0a2.20575,2.20575,0,0,1,2.2055,2.206v37.494a2.20575,2.20575,0,0,1-2.2055,2.206h0a2.20575,2.20575,0,0,1-2.2055-2.206v-37.494A2.20575,2.20575,0,0,1,418.06148,17.64648Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Value-6",
    className: "cls-11",
    d: "M351.196,46.68948a5.936,5.936,0,1,1-4.338-9.965v-10.991a16.91036,16.91036,0,1,0,0,33.82,16.817,16.817,0,0,0,12.388-5.354Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Value-7",
    className: "cls-14",
    d: "M346.748,25.73348v10.991a5.918,5.918,0,0,1,5.918,5.918v.001h10.992A16.961,16.961,0,0,0,346.748,25.73348Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Value-8",
    className: "cls-7",
    d: "M352.683,42.64348a5.867,5.867,0,0,1-2.259,4.627l6.761,8.607a16.769,16.769,0,0,0,6.473-13.234Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_35",
    "data-name": "Fill 35",
    className: "cls-9",
    d: "M83.549,59.54249a.03455.03455,0,0,1-.007.024c.007-.009.007-.037.007-.024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_37",
    "data-name": "Fill 37",
    className: "cls-9",
    d: "M83.549,59.55549v.007c0-.007.009-.031,0-.007"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_39",
    "data-name": "Fill 39",
    className: "cls-9",
    d: "M83.597,59.42949c-.011.03-.024.058-.032.087l.014-.041c-.153.382-.056.134.018-.046"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_41",
    "data-name": "Fill 41",
    className: "cls-9",
    d: "M83.564,59.51848l-.018.041c-.043.082.018-.041.018-.041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_47",
    "data-name": "Fill 47",
    className: "cls-9",
    d: "M83.54,59.56449c-.009.018.041-.068,0,0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Photo_Background",
    "data-name": "Photo Background",
    className: "cls-7",
    x: 48.258,
    y: 21.32248,
    width: 69.844,
    height: 46.317,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Mountains",
    className: "cls-14",
    d: "M74.726,34.55648,54.14,67.64048H95.311Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Mountains-2",
    className: "cls-11",
    d: "M94.943,43.37848l-18.012,24.261h36.025Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Sun",
    className: "cls-6",
    cx: 102.66299,
    cy: 36.76148,
    r: 6.617
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_35-2",
    "data-name": "Fill 35-2",
    className: "cls-9",
    d: "M434.231,373.4685a.063.063,0,0,0,.01.027c-.004-.007-.01-.037-.01-.027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_37-2",
    "data-name": "Fill 37-2",
    className: "cls-9",
    d: "M434.233,373.4835v.007c.006-.007-.007-.03,0-.007"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_39-2",
    "data-name": "Fill 39-2",
    className: "cls-9",
    d: "M434.187,373.3585c.01.029.024.057.035.087l-.017-.041c.153.382.056.133-.018-.046"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_41-2",
    "data-name": "Fill 41-2",
    className: "cls-9",
    d: "M434.22,373.4475l.018.041c.042.083-.018-.041-.018-.041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_47-2",
    "data-name": "Fill 47-2",
    className: "cls-9",
    d: "M434.243,373.4945c.009.018-.041-.068,0,0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Photo_Background-2",
    "data-name": "Photo Background-2",
    className: "cls-7",
    x: 382.03698,
    y: 316.8715,
    width: 104.398,
    height: 69.109,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Mountains-3",
    className: "cls-15",
    d: "M447.672,336.7225l30.183,49.258H417.488Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Mountains-4",
    className: "cls-14",
    d: "M416.551,349.9165l26.684,36.064H389.867Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Sun-2",
    className: "cls-11",
    cx: 405.19598,
    cy: 340.0305,
    r: 9.925
  }), /*#__PURE__*/React.createElement("path", {
    id: "Leg",
    className: "cls-16",
    d: "M137.951,255.11328l26.655,93.537,19.445,68.941h14.186l-20.665-162.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Leg-2",
    className: "cls-17",
    d: "M130.824,255.11328c-.617,48.21-2.719,74.5-3.366,78.885s-10.436,32.245-29.364,83.593h14.694q36.146-73.89,40.355-83.593c2.806-6.468,11.466-32.763,24.509-78.885Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shoe",
    className: "cls-16",
    d: "M96.78,430.82528l.735-15.439h15.439c10.982,7.72,28.673,12.5,28.673,12.5v2.941H113.69l-9.558-1.47v1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shoe-2",
    className: "cls-16",
    d: "M182.063,430.82528l.735-15.439h15.439c10.982,7.72,28.673,12.5,28.673,12.5v2.941H198.973l-9.558-1.47v1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Head-2",
    className: "cls-18",
    d: "M160.008,177.18266l6.074-28.312c-3.387-3.977-5.68-8.85-5.297-14.311,1.104-15.733,23.006-12.272,27.266-4.331s3.757,28.085-1.752,29.503c-2.2.566-6.874-.82-11.635-3.69l2.988,21.141Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Hair",
    className: "cls-16",
    d: "M174.781,155.17966c-1.185-3.58-1.637-13.886-1.746-16.931a4.4556,4.4556,0,0,0-.529-.031,4.411,4.411,0,0,0-3.08,7.566c-1.021,1.44-2.164,2.946-3.475,4.5-4.925-2.955-8.581-11.604-3.767-19.912a10.893,10.893,0,0,1,7.9-7.253,12.79994,12.79994,0,0,1,8.4-.619c4.951.425,9.371,1.935,10.625,2.831,0,4.687-.908,6.078-8.665,5.955a14.3079,14.3079,0,0,0-4.9,5.012c.011.152,1.037,14.113,5.36,14.113,4.347,0,8.035-2.76,9.942-2.76,1.39,0,1.08,1.74.158,3.03-.76,1.065-4.463,2.09-4.463,3.74,0,.932.933.93,1.745.928.626,0,1.18,0,1.18.424,0,1.618.515,4.662-2.3,4.662C184.326,160.43565,176.178,159.39965,174.781,155.17966Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skin",
    className: "cls-18",
    d: "M101.036,280.30741c-1-1.686-2.142-3.371-5.6-2.512-6.181,1.533-11.42,5.472-17.18.162-.708-.652-1.227-2.693,1.188-3.74,6.021-2.607,14.904-7.489,16.345-9.389q2.949-3.874,18.276-44.268l15.066,2.989q-22.729,42.353-24.378,44.895c-2.474,3.812-.165,10.8.687,14.477a4.641,4.641,0,0,1-1.049.131C102.578,283.05241,101.853,281.68041,101.036,280.30741Zm120.729-62.969,26.639-11.7a63.13143,63.13143,0,0,1,13.518-10.603c1.3-.414,3.519-.539,1.151,2.921s-4.7,7.206-3.758,8.418,3.688-.126,4.771,1.846q1.084,1.972-13.865,4.718l-19.956,15.297Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Coat_Back",
    "data-name": "Coat Back",
    className: "cls-19",
    d: "M170.07632,164.19385l6.35573-1.09073c13.843,13.427,19.50025,45.69009,28.72675,49.95944,8.72295,4.03669,21.0885.12792,35.78557-5.14983l4.50291,10.056c-13.35253,14.44967-41.80108,26.6574-53.33434,19.69361C173.67329,226.52346,169.41232,186.73189,170.07632,164.19385Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shirt",
    className: "cls-8",
    d: "M142.362,244.08641h56.251c2.57,0,2.086-3.712,1.714-5.584-4.288-21.615-21.028-44.915-21.028-75.684l-16.225-2.544C149.653,181.85841,145.012,208.43341,142.362,244.08641Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Coat_Front",
    "data-name": "Coat Front",
    className: "cls-19",
    d: "M96.045,264.56841q11.392-70.654,65.982-104.294h6.424s21.85,74.48,12.048,99.252H129.864a184.84635,184.84635,0,0,1,6.888-37.324q-17.201,31.026-28.917,44.672Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Hair_Back",
    "data-name": "Hair Back",
    className: "cls-20",
    d: "M456.942,198.153l.007-.113a15.807,15.807,0,0,0,14.048-15.71V166.891a15.806,15.806,0,0,0-15.805-15.807H453.72a15.806,15.806,0,0,0-15.632,13.443c-2.534,9.337-5.837,30.33-2.467,33.623Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Head-2-2",
    className: "cls-21",
    d: "M468.791,207.695l-6.074-28.312c3.387-3.977,5.68-8.85,5.3-14.31-1.1-15.733-23.006-12.272-27.266-4.331s-3.755,28.085,1.751,29.5c2.2.566,6.873-.82,11.635-3.69l-2.988,21.141Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Hair_Front",
    "data-name": "Hair Front",
    className: "cls-20",
    d: "M459.881,197.796H481.2a38.2692,38.2692,0,0,0-.119-6.67,18.34494,18.34494,0,0,0-1.071-4.539,17.178,17.178,0,0,0-3.758-5.558c-2.627-2.9-5.343-5.892-5.343-15.313-.185-.181-.368-.364-.548-.54-.524-.518-1.017-1.007-1.513-1.448l.024-.572a29.66514,29.66514,0,0,0-3.831-5.668,19.59968,19.59968,0,0,0-4.431-3.9,10.93491,10.93491,0,0,0-5.788-1.772c-3.792,0-6.764.784-9.075,2.4a17.62593,17.62593,0,0,0-4.411,4.919l-.005.007a8.63015,8.63015,0,0,0,3.361,4.659,31.01052,31.01052,0,0,0,5.519,2.986,48.3118,48.3118,0,0,1,5.372,2.758,4.043,4.043,0,1,1,2.548,7.181h-.184a81.38081,81.38081,0,0,0-.246,12.923C457.916,192.603,458.469,196.415,459.881,197.796Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skirt_Shadow",
    "data-name": "Skirt Shadow",
    className: "cls-22",
    d: "M497.163,340.829s-26.455,7.4-45.65,7.4-35.657-11.4-35.657-11.4,25.888-7.595,42.641-7.595S497.163,340.829,497.163,340.829Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Leg-3",
    className: "cls-21",
    d: "M436.245,355.34a4.21157,4.21157,0,0,0,.428-.835c2.357-6.235,40.118-73.492,43.88-85.789H438.04c-2.86,9.349-15.733,68.02-17.545,79.726-5.716,18.464-17.486,78.265-18.989,82.407-1.581,4.358,7.313,8.9,9.683,3.541,3.771-8.525,12.755-32.114,16.757-46.517C431.695,374.37,434.751,362.222,436.245,355.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Leg-2-2",
    className: "cls-21",
    d: "M471.027,363.552c17.264,4.363,80.411,12.251,84.744,13.489,4.457,1.273,8.367-7.916,2.856-9.906-8.767-3.167-32.925-10.485-47.572-13.47-11.782-2.4-22.532-4.362-29.75-5.51.612-20.275,3.407-68.93,1.575-79.438H445.263c1.757,10.077,16.608,83.605,19.368,90.965.876,2.628,3.49,3.788,6.4,3.871Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shoe-3",
    className: "cls-22",
    d: "M556.882,366.544a1.47,1.47,0,0,1,1.23011-1.6759l.00088-.00012.073-.01,5.114-.521a47.108,47.108,0,0,1,5.6,1.661l-7.215,40.843s-5.545.663-5.359-2.842.249-5.833.249-5.833l-5.11-20.477a.735.735,0,0,1,.534-.89178L552,376.797h.021l3.176-.7a16.66671,16.66671,0,0,0,2.393-4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shoe-2-2",
    className: "cls-22",
    d: "M411.831,432.689a1.47,1.47,0,0,1,1.864.92q.012.034.022.071l1.4,4.944a47.35276,47.35276,0,0,1-.662,5.8H372.994s-1.617-5.343,1.866-5.77,5.786-.77,5.786-.77l19.271-8.591a.735.735,0,0,1,.971.371l.008.02,1.239,3.006a16.66505,16.66505,0,0,0,5.24,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skirt",
    className: "cls-23",
    d: "M482.759,268.715s-24.865-7.114-47.053,0c-5.146,23.48-17.651,32.8-19.85,68.8,25,12.421,55.875-8.858,81.607,3.254C504.815,323.827,494.522,283.024,482.759,268.715Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skin-2",
    className: "cls-21",
    d: "M538.347,323.116c.82-.506,1.719-2.411-.452-3.9-5.41-3.713-13.2-10.2-14.258-12.341-2.154-4.371-21.005-60.624-21.005-60.624l-16.1.061s26.48,59.588,27.614,62.4c1.7,4.216-1.9,10.637-3.438,14.087,2.426,1.086,3.554-.3,4.788-1.686,1.315-1.478,2.753-2.956,6.017-1.437,4.176,1.943,7.629,5.027,11.745,5.027A9.552,9.552,0,0,0,538.347,323.116Zm-126.9-83.579-29.028-3.96a63.28012,63.28012,0,0,0-16.026-6.562c-1.373-.04-3.556.459-.3,3.171s6.553,5.711,5.973,7.158-3.6.909-4.106,3.134q-.5,2.226,14.727.724l23.554,9.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Clothes_Back",
    "data-name": "Clothes Back",
    className: "cls-10",
    d: "M458.535,195.195l-12.6.838c-3.108,28.079-20.016,45.813-57.866,39.807l-5.032,36.159c35.373,4.577,66.4-9.583,72.771-47.93C457.449,214.139,458.75,203.809,458.535,195.195Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Clothes",
    className: "cls-24",
    d: "M521.429,299.594Q508.301,229.75,466.014,191.52h-1.25l-.01.012-19.1,4.374c0,32.849-10.464,53.805-15.831,77.956h51.578c.726,8.345,1.176,16.923,1.406,25.732Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shade",
    className: "cls-25",
    d: "M470.92,273.862h10.483c-1.575-18.086-4.351-33.812-8.487-48.082.566,9.525.757,18.134.568,25.585-.241,9.488-1.1,17.057-2.564,22.493Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    className: "cls-6",
    d: "M320.518,87.122h-4.287v-.651h4.287Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    className: "cls-6",
    d: "M305.322,85.855V83.129h-1.817v2.725h-1.02V79.71h1.02v2.494h1.817V79.71h1.02v6.145Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    className: "cls-6",
    d: "M314.498,85.855l-1.723-4.339h-.026l.017,4.339h-.925V79.71h1.174l1.706,4.366h.026l-.009-4.366h.891v6.145Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    className: "cls-6",
    d: "M309.819,79.71h-1.276l-1.016,4.124-.852.289.267.806.344-.117-.257,1.043h.934l.342-1.389,1.616-.549.477,1.938h.934Zm-1.273,3.777.6-2.453h.063l.506,2.055Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustratieHome);
export default __webpack_public_path__ + "static/media/illustratie_home.16dee70ce870e6489e011fda3830e26f.svg";
export { ForwardRef as ReactComponent };